import {flow, types} from 'mobx-state-tree';
import * as api from '../../services/api';

// tslint:disable
export type TeamsListActions = {
  loadEntries: (offset?: number, limit?: number) => void;
  loadNextPage: () => void;
  loadPreviousPage: () => void;
  // tslint:disable-next-line:no-any
  receiveEntries: (data: any) => void;
};

export const TeamModel = types.model('TeamModel', {
  id: types.identifierNumber,
  name: types.string,
  email: types.optional(types.string, ''),
  avatar: types.optional(types.string, ''),
  serviceType: types.optional(types.string, ''),
  owner: types.model({
    id: types.number,
    firstName: types.string,
    lastName: types.optional(types.string, ''),
    avatar: types.optional(types.string, '')
  }),
  members: types.array(
    types.model({
      id: types.number,
      firstName: types.string,
      lastName: types.optional(types.string, ''),
      avatar: types.optional(types.string, '')
    })
  )
});

export type TeamModelType = typeof TeamModel.Type;

const PaginationModel = types.model('PaginationModel', {
  offset: types.optional(types.number, 0),
  limit: types.optional(types.number, 20),
  total: types.optional(types.number, 0),
  current: types.optional(types.number, 1)
});

const TeamsListModel = types
  .model('TeamsList', {
    entries: types.map(TeamModel),
    isLoading: types.optional(types.boolean, false),
    isError: types.optional(types.boolean, false),
    pagination: types.optional(PaginationModel, {}),

    // Delete listing
    isDeleting: types.optional(types.boolean, false),
    deletingTeam: types.maybe(
      types.model({id: types.number, name: types.string})
    )
  })
  .actions(self => {
    const withActions = (self as any) as TeamsListActions;

    return {
      loadEntries: flow(function*(params: any) {
        self.isLoading = true;
        const response = yield api.getTeams(params);
        if (response.status === 200 && response.data) {
          self.entries.clear();
          withActions.receiveEntries(response.data.teams);
          const {offset, limit} = params;
          const {total} = response.data.metadata;
          self.pagination.offset = offset || 0;
          self.pagination.limit = limit;
          if (!offset || offset === 0) {
            self.pagination.current = 1;
          } else {
            self.pagination.current = Math.ceil(offset / limit) + 1;
          }

          self.pagination.total = total;
        } else {
          self.isError = true;
        }
        self.isLoading = false;
      }),
      // tslint:disable-next-line:no-any
      receiveEntries: (entries: any) => {
        if (!entries || entries.length === 0) {
          return;
        }
        const received = entries.reduce(
          (results: {[id: string]: TeamModelType}, r: TeamModelType) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );
        self.entries.merge(received);
      },
      clearEntries() {
        self.entries.clear();
      },
      deleteTeam: flow(function*(teamId: number) {
        self.isDeleting = true;
        const response = yield api.deleteTeam(teamId);
        self.entries.delete(String(teamId));
        if (response.status === 200 && response.data) {
        } else {
          self.isDeleting = false;
        }
        self.isDeleting = false;
      }),
      setCurrentDeleteTeam: (team: {id: number; name: string}) => {
        self.deletingTeam = team;
      }
    };
  });

export type TeamsListType = typeof TeamsListModel.Type;
export default TeamsListModel;



// WEBPACK FOOTER //
// ./src/models/TeamsListModel/TeamsListModel.ts